// extracted by mini-css-extract-plugin
export var summitFeaturedOverlay = "event-module--summit-featured-overlay--77e74";
export var summitTagCustomersOnly = "event-module--summit-tag-customers-only--08468";
export var summitTagHighlight = "event-module--summit-tag-highlight--b672a";
export var summitTags = "event-module--summit-tags--13024";